import React, { useState, useEffect } from 'react';

import {
  Stack,
  IconButton,
  FormControl,
  Paper,
  InputAdornment,
  OutlinedInput,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/DisabledByDefaultRounded';
import { NumericFormatCustom } from 'src/sections/scenarios/NumericFormatCustom';

export const GoalRow = ({ value, onChange, onDelete }) => {
  const [amount, setAmount] = useState(value?.amount ? parseFloat(value?.amount) : null);

  useEffect(() => {
    onChange(value?.category, Number(amount));
  }, [amount]);

  const name = value?.category ?? 'Unknown Category';
  // categoryMap(value?.category, 'primaryKey')?.primary ??
  // categoryMap(value?.category, 'key')?.detailed ??

  return (
    <Paper sx={{ p: '8px', alignItems: 'center', minWidth: 300 }}>
      <Stack spacing={0.5} sx={{ width: '100%' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography fontWeight="bold" variant="body2" sx={{ width: '60%' }}>
            {name}
          </Typography>
          <FormControl size="small">
            <OutlinedInput
              id="amount"
              value={amount}
              onChange={(e) => setAmount(parseFloat(e.target.value))}
              startAdornment={<InputAdornment position="start">$</InputAdornment>}
              endAdornment={<InputAdornment position="end">/ month</InputAdornment>}
              inputComponent={NumericFormatCustom}
              inputProps={{
                'aria-label': `${value?.category} Amount`,
              }}
            />
          </FormControl>
          <IconButton onClick={() => onDelete(value?.category)} size="small" color="error">
            <DeleteIcon />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
};
